import * as React from 'react';
import { Grid, Card, IconButton, CardContent } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { PublicVideoUrl } from 'features/api_url';
const UploadVideoList = (props) => {

    const { file, onDelete } = props;
    console.log("Rendering video list");

    const video_url = URL.createObjectURL(file);


    return(
        <Card sx={{ height:"100%",backgroundColor:"#f2f2f2", position:"relative"}}>
            <CardContent>
                <video width="50%" src={video_url} controls />
                <IconButton 
                    aria-label="delete" 
                    sx={{position:"absolute",top:"5px",right:"5px",color:"grey"}}
                    onClick={() => onDelete(0)}
                >
                    <DeleteIcon />
                </IconButton>
            </CardContent>
        </Card>
    )
}

export default UploadVideoList;